module.exports = __webpack_public_path__ + "assets/webgl/LM.1.jpg.43468929.webp";